module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "order-modal"
    }
  }, [_c('div', {
    staticClass: "tingle-modal order-modal-mask order-loading-modal"
  }, [_c('div', {
    staticClass: "tingle-modal-box order-modal-wrapper"
  }, [_c('div', {
    staticClass: "tingle-modal-box__content order-modal-container"
  }, [_c('div', {
    staticClass: "order-loading-modal__logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/branding/logo.svg"),
      "alt": "Öpfelchasper"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "order-loading-modal__heading"
  }, [_vm._v(_vm._s(_vm.text))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30f08876","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Loading.vue
// module id = 898
// module chunks = 0